import { URL_QUERY_STRING } from "./storage-keys";

export const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export const setItem = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

export const removeItem = (key: string): void => {
  localStorage.removeItem(key);
};

export const getSiteCode = () => {
  const query = getItem(URL_QUERY_STRING);
  const url = new URLSearchParams(query ? query : '');
  const queryObject = Object.fromEntries(url);
  const siteCode = queryObject['site-code'] || 'tw-profile';
  return siteCode;
};